export function getContentWidth() {
    return document.getElementsByTagName("nz-header")[0].clientWidth;
}